import PropTypes from 'prop-types';
import React from 'react';
import { displayNameLimits } from '@data/navigation';
import { adjustStringLength } from '@utils/navigationHelpers';

const StaticNavigationList = ({ items }) => (
  <div className="static-navigation-list">
    {items.map((item) => {
      const [navLink] = item.links;
      return (
        <div
          className="menu-item d-block ml-3 position-relative"
          key={`${navLink.title}`}
        >
          <a href={navLink.link} title={navLink.title} className="d-block w-100 pl-3 py-2">
            {adjustStringLength(navLink.title, displayNameLimits.headerStaticTitle)}
          </a>
        </div>
      );
    })}
  </div>
);

const itemLinkType = PropTypes.shape({
  link: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  source: PropTypes.string.isRequired,
});

const itemsType = PropTypes.shape({
  title: PropTypes.string,
  type: PropTypes.string,
  links: PropTypes.arrayOf(itemLinkType),
});

StaticNavigationList.propTypes = {
  items: PropTypes.arrayOf(itemsType).isRequired,
};

export default StaticNavigationList;
